import { jsxs as h, jsx as a, Fragment as de } from "react/jsx-runtime";
import O, { useState as $, useMemo as y, useEffect as ue } from "react";
import { Popover as F, IconButton as pt, Icon as U, InputGroup as he, Input as xt, Portal as Ht, Stack as ot, Box as P, Text as z, HStack as V, ButtonGroup as ge, Button as bt, NativeSelect as Y, Grid as Ot, Dialog as M, CloseButton as fe } from "@chakra-ui/react";
var _t = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, Tt = O.createContext && /* @__PURE__ */ O.createContext(_t), me = ["attr", "size", "title"];
function pe(t, e) {
  if (t == null) return {};
  var r = xe(t, e), n, s;
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(t);
    for (s = 0; s < u.length; s++)
      n = u[s], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function xe(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function at() {
  return at = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, at.apply(this, arguments);
}
function Wt(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function it(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Wt(Object(r), !0).forEach(function(n) {
      be(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Wt(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function be(t, e, r) {
  return e = ke(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function ke(t) {
  var e = Le(t, "string");
  return typeof e == "symbol" ? e : e + "";
}
function Le(t, e) {
  if (typeof t != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function $t(t) {
  return t && t.map((e, r) => /* @__PURE__ */ O.createElement(e.tag, it({
    key: r
  }, e.attr), $t(e.child)));
}
function c(t) {
  return (e) => /* @__PURE__ */ O.createElement(we, at({
    attr: it({}, t.attr)
  }, e), $t(t.child));
}
function we(t) {
  var e = (r) => {
    var {
      attr: n,
      size: s,
      title: u
    } = t, p = pe(t, me), L = s || r.size || "1em", x;
    return r.className && (x = r.className), t.className && (x = (x ? x + " " : "") + t.className), /* @__PURE__ */ O.createElement("svg", at({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, r.attr, n, p, {
      className: x,
      style: it(it({
        color: t.color || r.color
      }, r.style), t.style),
      height: L,
      width: L,
      xmlns: "http://www.w3.org/2000/svg"
    }), u && /* @__PURE__ */ O.createElement("title", null, u), t.children);
  };
  return Tt !== void 0 ? /* @__PURE__ */ O.createElement(Tt.Consumer, null, (r) => e(r)) : e(_t);
}
function He(t) {
  return c({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M12 5v14" }, child: [] }, { tag: "path", attr: { d: "m19 12-7 7-7-7" }, child: [] }] })(t);
}
function _e(t) {
  return c({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M5 12h14" }, child: [] }, { tag: "path", attr: { d: "m12 5 7 7-7 7" }, child: [] }] })(t);
}
function $e(t) {
  return c({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "m5 12 7-7 7 7" }, child: [] }, { tag: "path", attr: { d: "M12 19V5" }, child: [] }] })(t);
}
function Bt(t) {
  return c({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "rect", attr: { width: "18", height: "18", x: "3", y: "4", rx: "2" }, child: [] }, { tag: "path", attr: { d: "M16 2v4" }, child: [] }, { tag: "path", attr: { d: "M3 10h18" }, child: [] }, { tag: "path", attr: { d: "M8 2v4" }, child: [] }, { tag: "path", attr: { d: "M17 14h-6" }, child: [] }, { tag: "path", attr: { d: "M13 18H7" }, child: [] }, { tag: "path", attr: { d: "M7 14h.01" }, child: [] }, { tag: "path", attr: { d: "M17 18h.01" }, child: [] }] })(t);
}
function Ge(t) {
  return c({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M20 6 9 17l-5-5" }, child: [] }] })(t);
}
function qe(t) {
  return c({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "m6 9 6 6 6-6" }, child: [] }] })(t);
}
function ve(t) {
  return c({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "m15 18-6-6 6-6" }, child: [] }] })(t);
}
function ye(t) {
  return c({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "m9 18 6-6-6-6" }, child: [] }] })(t);
}
function Ue(t) {
  return c({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "m7 15 5 5 5-5" }, child: [] }, { tag: "path", attr: { d: "m7 9 5-5 5 5" }, child: [] }] })(t);
}
function Ve(t) {
  return c({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "circle", attr: { cx: "12", cy: "12", r: "10" }, child: [] }, { tag: "path", attr: { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" }, child: [] }, { tag: "path", attr: { d: "M12 17h.01" }, child: [] }] })(t);
}
function Qe(t) {
  return c({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "circle", attr: { cx: "12", cy: "12", r: "1" }, child: [] }, { tag: "circle", attr: { cx: "19", cy: "12", r: "1" }, child: [] }, { tag: "circle", attr: { cx: "5", cy: "12", r: "1" }, child: [] }] })(t);
}
function Je(t) {
  return c({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17" }, child: [] }, { tag: "path", attr: { d: "m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9" }, child: [] }, { tag: "path", attr: { d: "m2 16 6 6" }, child: [] }, { tag: "circle", attr: { cx: "16", cy: "9", r: "2.9" }, child: [] }, { tag: "circle", attr: { cx: "6", cy: "5", r: "3" }, child: [] }] })(t);
}
function Ke(t) {
  return c({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "rect", attr: { width: "7", height: "7", x: "3", y: "3", rx: "1" }, child: [] }, { tag: "rect", attr: { width: "7", height: "7", x: "14", y: "3", rx: "1" }, child: [] }, { tag: "rect", attr: { width: "7", height: "7", x: "14", y: "14", rx: "1" }, child: [] }, { tag: "rect", attr: { width: "7", height: "7", x: "3", y: "14", rx: "1" }, child: [] }] })(t);
}
function Ze(t) {
  return c({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" }, child: [] }, { tag: "polyline", attr: { points: "16 17 21 12 16 7" }, child: [] }, { tag: "line", attr: { x1: "21", x2: "9", y1: "12", y2: "12" }, child: [] }] })(t);
}
function Xe(t) {
  return c({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "line", attr: { x1: "4", x2: "20", y1: "12", y2: "12" }, child: [] }, { tag: "line", attr: { x1: "4", x2: "20", y1: "6", y2: "6" }, child: [] }, { tag: "line", attr: { x1: "4", x2: "20", y1: "18", y2: "18" }, child: [] }] })(t);
}
function tr(t) {
  return c({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" }, child: [] }, { tag: "path", attr: { d: "M19 10v2a7 7 0 0 1-14 0v-2" }, child: [] }, { tag: "line", attr: { x1: "12", x2: "12", y1: "19", y2: "22" }, child: [] }] })(t);
}
function er(t) {
  return c({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" }, child: [] }] })(t);
}
function rr(t) {
  return c({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "rect", attr: { width: "18", height: "18", x: "3", y: "3", rx: "2" }, child: [] }, { tag: "path", attr: { d: "M9 3v18" }, child: [] }, { tag: "path", attr: { d: "m16 15-3-3 3-3" }, child: [] }] })(t);
}
function nr(t) {
  return c({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "rect", attr: { width: "18", height: "18", x: "3", y: "3", rx: "2" }, child: [] }, { tag: "path", attr: { d: "M9 3v18" }, child: [] }, { tag: "path", attr: { d: "m14 9 3 3-3 3" }, child: [] }] })(t);
}
function or(t) {
  return c({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" }, child: [] }, { tag: "path", attr: { d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7" }, child: [] }, { tag: "path", attr: { d: "M7 3v4a1 1 0 0 0 1 1h7" }, child: [] }] })(t);
}
function ar(t) {
  return c({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "circle", attr: { cx: "11", cy: "11", r: "8" }, child: [] }, { tag: "path", attr: { d: "m21 21-4.3-4.3" }, child: [] }] })(t);
}
function ir(t) {
  return c({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" }, child: [] }, { tag: "circle", attr: { cx: "12", cy: "12", r: "3" }, child: [] }] })(t);
}
function lr(t) {
  return c({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "circle", attr: { cx: "12", cy: "12", r: "4" }, child: [] }, { tag: "path", attr: { d: "M12 2v2" }, child: [] }, { tag: "path", attr: { d: "M12 20v2" }, child: [] }, { tag: "path", attr: { d: "m4.93 4.93 1.41 1.41" }, child: [] }, { tag: "path", attr: { d: "m17.66 17.66 1.41 1.41" }, child: [] }, { tag: "path", attr: { d: "M2 12h2" }, child: [] }, { tag: "path", attr: { d: "M20 12h2" }, child: [] }, { tag: "path", attr: { d: "m6.34 17.66-1.41 1.41" }, child: [] }, { tag: "path", attr: { d: "m19.07 4.93-1.41 1.41" }, child: [] }] })(t);
}
function cr(t) {
  return c({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M12 3v18" }, child: [] }, { tag: "rect", attr: { width: "18", height: "18", x: "3", y: "3", rx: "2" }, child: [] }, { tag: "path", attr: { d: "M3 9h18" }, child: [] }, { tag: "path", attr: { d: "M3 15h18" }, child: [] }] })(t);
}
function sr(t) {
  return c({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M11.5 15H7a4 4 0 0 0-4 4v2" }, child: [] }, { tag: "path", attr: { d: "M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z" }, child: [] }, { tag: "circle", attr: { cx: "10", cy: "7", r: "4" }, child: [] }] })(t);
}
function dr(t) {
  return c({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "m9 12 2 2 4-4" }, child: [] }, { tag: "path", attr: { d: "M5 7c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v12H5V7Z" }, child: [] }, { tag: "path", attr: { d: "M22 19H2" }, child: [] }] })(t);
}
function ur(t) {
  return c({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" }, child: [] }] })(t);
}
function hr(t) {
  return c({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M18 6 6 18" }, child: [] }, { tag: "path", attr: { d: "m6 6 12 12" }, child: [] }] })(t);
}
const Me = (t) => !Number.isNaN(t.getTime()), N = (t) => {
  const e = t.trim();
  if (e.length === 0) return null;
  const r = new Date(e);
  return Me(r) ? r : null;
}, G = (t) => t.toISOString(), B = (t) => new Date(t.getFullYear(), t.getMonth(), t.getDate(), 0, 0, 0, 0), j = (t) => new Date(t.getFullYear(), t.getMonth(), t.getDate(), 23, 59, 59, 999), E = (t, e) => {
  const r = new Date(t);
  return r.setDate(r.getDate() + e), r;
}, W = (t) => new Date(t.getFullYear(), t.getMonth(), 1, 0, 0, 0, 0), Rt = (t) => new Date(t.getFullYear(), t.getMonth() + 1, 0, 23, 59, 59, 999), Ft = (t) => new Date(t.getFullYear(), 0, 1, 0, 0, 0, 0), Pt = (t) => new Date(t.getFullYear(), 11, 31, 23, 59, 59, 999), Gt = (t) => Math.floor(t.getMonth() / 3) + 1, zt = (t) => {
  const r = (Gt(t) - 1) * 3;
  return new Date(t.getFullYear(), r, 1, 0, 0, 0, 0);
}, Yt = (t) => {
  const r = Gt(t) * 3 - 1;
  return new Date(t.getFullYear(), r + 1, 0, 23, 59, 59, 999);
}, kt = (t, e) => t.getFullYear() === e.getFullYear() && t.getMonth() === e.getMonth() && t.getDate() === e.getDate(), D = (t, e) => {
  const r = new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime(), n = new Date(e.getFullYear(), e.getMonth(), e.getDate()).getTime();
  return r === n ? 0 : r < n ? -1 : 1;
}, De = (t, e) => {
  const r = N(t.from), n = N(t.to);
  if (!r && !n) return e.placeholder;
  const s = new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric"
  }), u = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "2-digit"
  }), p = (L) => {
    const x = s.format(L);
    return e.withTime ? `${x} ${u.format(L)}` : x;
  };
  return e.selection === "single" ? p(r ?? n ?? /* @__PURE__ */ new Date()) : r && n ? `${p(r)} – ${p(n)}` : p(r ?? n ?? /* @__PURE__ */ new Date());
}, Ce = (t) => {
  if (!t.from && !t.to) return "All time";
  const e = (s) => {
    const u = s.getMonth() + 1, p = s.getDate(), L = String(s.getFullYear()).slice(-2);
    return `${u}/${p}/${L}`;
  }, r = t.from ? e(t.from) : "", n = t.to ? e(t.to) : "";
  return r && n ? `${r} – ${n}` : r || n || "All time";
}, Se = (t) => {
  const e = t.trim(), r = /^(\d{2}):(\d{2})$/.exec(e);
  if (!r) return null;
  const n = Number.parseInt(r[1], 10), s = Number.parseInt(r[2], 10);
  return !Number.isFinite(n) || !Number.isFinite(s) || n < 0 || n > 23 || s < 0 || s > 59 ? null : { hour: n, minute: s };
}, Nt = (t, e) => {
  const r = Se(e);
  if (!r) return t;
  const n = new Date(t);
  return n.setHours(r.hour, r.minute, 0, 0), n;
}, vt = (t) => {
  const e = B(t), n = (e.getDay() + 6) % 7;
  return E(e, -n);
}, Et = (t) => {
  const e = vt(t);
  return j(E(e, 6));
}, Lt = (t, e) => {
  const r = j(t);
  return { from: B(E(r, -(e - 1))), to: r };
}, je = [
  {
    id: "thisWeek",
    label: "This week",
    getRange: (t) => ({ from: vt(t), to: Et(t) })
  },
  {
    id: "thisMonth",
    label: "This month",
    getRange: (t) => ({ from: W(t), to: Rt(t) })
  },
  {
    id: "thisQuarter",
    label: "This quarter",
    getRange: (t) => ({ from: zt(t), to: Yt(t) })
  },
  {
    id: "thisYear",
    label: "This year",
    getRange: (t) => ({ from: Ft(t), to: Pt(t) })
  },
  {
    id: "lastWeek",
    label: "Last week",
    getRange: (t) => {
      const e = E(t, -7);
      return { from: vt(e), to: Et(e) };
    }
  },
  {
    id: "lastMonth",
    label: "Last month",
    getRange: (t) => {
      const e = new Date(t.getFullYear(), t.getMonth() - 1, t.getDate());
      return { from: W(e), to: Rt(e) };
    }
  },
  {
    id: "lastQuarter",
    label: "Last quarter",
    getRange: (t) => {
      const e = new Date(t.getFullYear(), t.getMonth() - 3, t.getDate());
      return { from: zt(e), to: Yt(e) };
    }
  },
  {
    id: "lastYear",
    label: "Last year",
    getRange: (t) => {
      const e = new Date(t.getFullYear() - 1, t.getMonth(), t.getDate());
      return { from: Ft(e), to: Pt(e) };
    }
  },
  {
    id: "last30Days",
    label: "Last 30 days",
    getRange: (t) => Lt(t, 30)
  },
  {
    id: "last90Days",
    label: "Last 90 days",
    getRange: (t) => Lt(t, 90)
  },
  {
    id: "last365Days",
    label: "Last 365 days",
    getRange: (t) => Lt(t, 365)
  }
], Oe = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], Te = () => /* @__PURE__ */ new Date(), It = (t) => String(t).padStart(2, "0"), At = (t) => `${It(t.getHours())}:${It(t.getMinutes())}`, q = (t, e) => new Date(t.getFullYear(), t.getMonth() + e, 1, 0, 0, 0, 0), We = (t, e) => new Date(t.getFullYear() + e, t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), 0, 0), Be = (t) => {
  const e = B(t), n = (e.getDay() + 6) % 7;
  return E(e, -n);
}, Re = (t) => {
  const e = Be(t), r = [];
  for (let n = 0; n < 42; n++)
    r.push(E(e, n));
  return r;
}, wt = (t) => !t.from || !t.to || D(t.from, t.to) <= 0 ? t : { from: t.to, to: t.from }, Fe = ({
  selection: t,
  withTime: e = !1,
  value: r,
  onValueChange: n,
  onOpenChange: s,
  placeholder: u = t === "range" ? "Date Range" : "Date",
  ariaLabel: p,
  triggerVariant: L = "input",
  triggerIcon: x,
  presets: Q = je,
  getNow: J = Te,
  allowFutureDates: K = !0,
  maxFutureYears: I = 2,
  inputWidth: lt,
  minDate: T,
  maxDate: A
}) => {
  const [ct, R] = $(!1), w = y(() => J(), [J]), b = y(() => {
    if (!T) return null;
    const o = T instanceof Date ? T : N(T);
    return o ? B(o) : null;
  }, [T]), C = y(() => {
    if (A) {
      const i = A instanceof Date ? A : N(A);
      return j(i || w);
    }
    if (!K) return j(w);
    const o = Number.isFinite(I) ? Math.max(0, Math.trunc(I)) : 2;
    return j(We(w, o));
  }, [K, A, I, w]), qt = (o) => o.to && o.to.getTime() > C.getTime() ? { ...o, to: C } : o, st = y(() => W(C), [C]), dt = y(() => t === "range" ? q(st, -1) : st, [st, t]), v = (o) => {
    const i = W(o);
    return D(i, dt) > 0 ? dt : i;
  }, [k, H] = $({ from: null, to: null }), [yt, Z] = $("00:00"), [Mt, X] = $("23:59"), [tt, S] = $(() => v(W(w)));
  ue(() => {
    if (!ct) return;
    const o = N(r.from), i = N(r.to), d = wt({
      from: o,
      to: t === "single" ? null : i
    });
    H(d), e ? (Z(o ? At(o) : "00:00"), X(i ? At(i) : "23:59")) : (Z("00:00"), X("23:59")), S(v(W(o ?? i ?? w)));
  }, [w, ct, t, r.from, r.to, e]);
  const ut = y(
    () => De(r, { placeholder: u, withTime: e, selection: t }),
    [u, t, r, e]
  ), Ut = y(() => ut === u, [ut, u]), Vt = t === "range", Dt = tt, Qt = q(tt, 1), Jt = y(() => {
    const o = w.getFullYear() - 10, i = b ? Math.max(b.getFullYear(), o) : o, d = C.getFullYear(), g = [];
    for (let f = i; f <= d; f++) g.push(f);
    return g;
  }, [C, b, w]), _ = y(() => wt(k), [k]), Kt = (o) => {
    const { from: i, to: d } = _;
    if (!i) return !1;
    if (t === "single") return kt(o, i);
    const g = d ?? i;
    return D(o, i) >= 0 && D(o, g) <= 0;
  }, Ct = (o, i) => {
    const { from: d, to: g } = _, f = i === "from" ? d : g;
    return f ? kt(o, f) : !1;
  }, Zt = (o) => {
    if (t !== "range") return !1;
    const { from: i, to: d } = _;
    return !i || !d ? !1 : D(o, i) > 0 && D(o, d) < 0;
  }, Xt = (o) => {
    if (t === "single") {
      H({ from: o, to: null });
      return;
    }
    if (!k.from || k.from && k.to) {
      H({ from: o, to: null });
      return;
    }
    H(wt({ from: k.from, to: o }));
  }, te = () => {
    if (!k.from && !k.to) {
      n({ from: "", to: "" }), R(!1);
      return;
    }
    const o = k.from ?? k.to, i = t === "range" ? k.to ?? k.from : null;
    if (!o) {
      n({ from: "", to: "" }), R(!1);
      return;
    }
    if (!e) {
      const f = G(B(o)), gt = G(j(t === "range" ? i ?? o : o));
      n({ from: f, to: gt }), R(!1);
      return;
    }
    const d = Nt(B(o), yt), g = t === "range" ? Nt(B(i ?? o), Mt) : null;
    n({
      from: G(d),
      to: t === "range" ? G(g ?? d) : ""
    }), R(!1);
  }, ee = ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"], ht = ({
    monthStart: o,
    panel: i
  }) => {
    const d = y(() => Re(o), [o]), g = o.getMonth(), f = o.getFullYear(), gt = C.getFullYear(), ne = C.getMonth(), oe = (b == null ? void 0 : b.getFullYear()) ?? 0, ae = (b == null ? void 0 : b.getMonth()) ?? 0, ie = D(q(tt, 1), dt) > 0, le = b ? D(tt, W(b)) <= 0 : !1;
    return /* @__PURE__ */ h(
      ot,
      {
        gap: "2",
        minW: { base: "100%", md: "240px", lg: "260px" },
        w: "full",
        children: [
          /* @__PURE__ */ h(V, { justify: "space-between", align: "center", children: [
            i === "left" || i === "single" ? /* @__PURE__ */ a(
              pt,
              {
                "aria-label": "Previous month",
                variant: "ghost",
                size: "sm",
                disabled: le,
                onClick: () => S((l) => v(q(l, -1))),
                children: /* @__PURE__ */ a(U, { as: ve, boxSize: "5" })
              }
            ) : /* @__PURE__ */ a(P, { boxSize: "5" }),
            /* @__PURE__ */ h(V, { gap: "2", children: [
              /* @__PURE__ */ h(Y.Root, { size: "sm", children: [
                /* @__PURE__ */ a(
                  Y.Field,
                  {
                    w: "auto",
                    minW: "72px",
                    value: String(g),
                    onChange: (l) => {
                      const m = Number.parseInt(l.currentTarget.value, 10);
                      if (Number.isFinite(m)) {
                        if (i === "left") {
                          S(v(new Date(f, m, 1, 0, 0, 0, 0)));
                          return;
                        }
                        if (i === "single") {
                          S(v(new Date(f, m, 1, 0, 0, 0, 0)));
                          return;
                        }
                        S(v(new Date(f, m - 1, 1, 0, 0, 0, 0)));
                      }
                    },
                    children: Oe.map((l, m) => {
                      const ft = f === gt && m > ne, mt = f === oe && m < ae;
                      return /* @__PURE__ */ a(
                        "option",
                        {
                          value: String(m),
                          disabled: ft || mt,
                          children: l
                        },
                        l
                      );
                    })
                  }
                ),
                /* @__PURE__ */ a(Y.Indicator, {})
              ] }),
              /* @__PURE__ */ h(Y.Root, { size: "sm", children: [
                /* @__PURE__ */ a(
                  Y.Field,
                  {
                    w: "auto",
                    minW: "92px",
                    value: String(f),
                    onChange: (l) => {
                      const m = Number.parseInt(l.currentTarget.value, 10);
                      if (Number.isFinite(m)) {
                        if (i === "left") {
                          S(v(new Date(m, g, 1, 0, 0, 0, 0)));
                          return;
                        }
                        if (i === "single") {
                          S(v(new Date(m, g, 1, 0, 0, 0, 0)));
                          return;
                        }
                        S(v(new Date(m, g - 1, 1, 0, 0, 0, 0)));
                      }
                    },
                    children: Jt.map((l) => /* @__PURE__ */ a("option", { value: String(l), children: String(l) }, String(l)))
                  }
                ),
                /* @__PURE__ */ a(Y.Indicator, {})
              ] })
            ] }),
            i === "right" || i === "single" ? /* @__PURE__ */ a(
              pt,
              {
                "aria-label": "Next month",
                variant: "ghost",
                size: "sm",
                disabled: ie,
                onClick: () => S((l) => v(q(l, 1))),
                children: /* @__PURE__ */ a(U, { as: ye, boxSize: "5" })
              }
            ) : /* @__PURE__ */ a(P, { boxSize: "5" })
          ] }),
          /* @__PURE__ */ a(Ot, { templateColumns: "repeat(7, 1fr)", gap: "1", px: "1", children: ee.map((l) => /* @__PURE__ */ a(z, { fontSize: "xs", color: "fg.subtle", textAlign: "center", children: l }, l)) }),
          /* @__PURE__ */ a(Ot, { templateColumns: "repeat(7, 1fr)", gap: "0", px: "1", children: d.map((l) => {
            const m = l.getMonth() !== g, ft = D(l, C) > 0, mt = b ? D(l, b) < 0 : !1, St = ft || mt;
            if (m)
              return /* @__PURE__ */ a(P, { w: "full", h: "32px" }, l.toISOString());
            const et = Kt(l), rt = Ct(l, "from"), nt = Ct(l, "to"), ce = Zt(l), jt = kt(l, w), se = t === "range" && !!(_.from && _.to) && et && (ce || rt || nt);
            return /* @__PURE__ */ a(
              P,
              {
                w: "full",
                h: "32px",
                bg: se ? "bg.subtle" : "transparent",
                borderTopLeftRadius: rt ? "full" : "0",
                borderBottomLeftRadius: rt ? "full" : "0",
                borderTopRightRadius: nt ? "full" : "0",
                borderBottomRightRadius: nt ? "full" : "0",
                children: /* @__PURE__ */ a(
                  bt,
                  {
                    variant: !!(et && (t === "single" || rt || nt)) ? "solid" : "ghost",
                    size: "sm",
                    h: "32px",
                    px: "0",
                    w: "full",
                    borderRadius: "full",
                    color: St ? "fg.subtle" : void 0,
                    border: jt && !et ? "1px solid" : void 0,
                    borderColor: jt && !et ? "border.emphasized" : void 0,
                    disabled: St,
                    onClick: () => Xt(l),
                    children: String(l.getDate())
                  }
                )
              },
              l.toISOString()
            );
          }) })
        ]
      }
    );
  }, re = t === "range" && Q.length > 0;
  return /* @__PURE__ */ h(
    F.Root,
    {
      open: ct,
      onOpenChange: (o) => {
        R(o.open), s == null || s(o.open);
      },
      lazyMount: !0,
      unmountOnExit: !0,
      children: [
        /* @__PURE__ */ a(F.Trigger, { asChild: !0, children: L === "icon" ? /* @__PURE__ */ a(
          pt,
          {
            "aria-label": p ?? u,
            variant: "ghost",
            size: "sm",
            boxSize: "8",
            minW: "8",
            children: /* @__PURE__ */ a(U, { as: x ?? Bt, boxSize: "4" })
          }
        ) : /* @__PURE__ */ a(
          he,
          {
            w: lt,
            startElement: /* @__PURE__ */ a(U, { as: x ?? Bt, opacity: 0.7 }),
            children: /* @__PURE__ */ a(
              xt,
              {
                h: "40px",
                value: ut,
                readOnly: !0,
                "aria-label": p ?? u,
                color: Ut ? "fg.subtle" : "fg"
              }
            )
          }
        ) }),
        /* @__PURE__ */ a(Ht, { children: /* @__PURE__ */ a(F.Positioner, { children: /* @__PURE__ */ h(
          F.Content,
          {
            w: t === "single" ? { base: "calc(100vw - 24px)", md: "fit-content", lg: "fit-content" } : { base: "calc(100vw - 24px)", lg: "fit-content" },
            maxW: t === "single" ? { base: "calc(100vw - 24px)", md: "360px", lg: "360px" } : { base: "calc(100vw - 24px)", md: "100vw", lg: "1024px" },
            maxH: "80vh",
            bg: "bg",
            borderColor: "border",
            boxShadow: "lg",
            display: "flex",
            flexDirection: "column",
            overflowX: "hidden",
            children: [
              /* @__PURE__ */ h(F.Body, { flex: "1", overflowY: "auto", pb: "6", children: [
                /* @__PURE__ */ h(ot, { direction: { base: "column", lg: "row" }, align: "stretch", gap: "6", children: [
                  /* @__PURE__ */ a(ot, { direction: { base: "column", md: "row" }, align: "start", gap: "6", flex: "0", children: Vt ? /* @__PURE__ */ h(de, { children: [
                    /* @__PURE__ */ a(ht, { monthStart: Dt, panel: "left" }),
                    /* @__PURE__ */ a(ht, { monthStart: Qt, panel: "right" })
                  ] }) : /* @__PURE__ */ a(ht, { monthStart: Dt, panel: "single" }) }),
                  re ? /* @__PURE__ */ h(
                    P,
                    {
                      w: { base: "full", lg: "280px" },
                      display: "flex",
                      flexDirection: "column",
                      minH: "0",
                      maxH: { base: "240px", md: "240px", lg: "288px" },
                      borderTopWidth: { base: "1px", md: "1px", lg: "0" },
                      borderLeftWidth: { base: "0", lg: "1px" },
                      borderColor: "border.muted",
                      pt: { base: "4", md: "4", lg: "0" },
                      pl: { base: "0", lg: "6" },
                      children: [
                        /* @__PURE__ */ a(z, { fontSize: "xs", color: "fg.subtle", mb: "2", letterSpacing: "wide", children: "DATE RANGE" }),
                        /* @__PURE__ */ a(ot, { gap: "1", flex: "1", minH: "0", overflowY: "auto", pr: "1", children: Q.map((o) => {
                          const i = o.getRange(w), d = qt({ from: i.from, to: i.to }), g = Ce(d);
                          return /* @__PURE__ */ h(
                            V,
                            {
                              justify: "space-between",
                              gap: "6",
                              py: "1.5",
                              px: "2",
                              borderRadius: "md",
                              _hover: { bg: "bg.subtle" },
                              cursor: "pointer",
                              onClick: () => {
                                H({ from: d.from, to: d.to }), Z("00:00"), X("23:59");
                              },
                              children: [
                                /* @__PURE__ */ a(z, { fontSize: "sm", color: "fg", whiteSpace: "nowrap", flexShrink: 0, children: o.label }),
                                /* @__PURE__ */ a(
                                  z,
                                  {
                                    fontSize: "sm",
                                    color: "fg.subtle",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    flex: "1",
                                    minW: "0",
                                    textAlign: "end",
                                    children: g
                                  }
                                )
                              ]
                            },
                            o.id
                          );
                        }) })
                      ]
                    }
                  ) : null
                ] }),
                e ? /* @__PURE__ */ h(P, { mt: "4", pt: "4", borderTop: "1px solid", borderColor: "border.muted", children: [
                  /* @__PURE__ */ a(z, { fontSize: "sm", color: "fg", mb: "2", children: "Add time" }),
                  /* @__PURE__ */ h(V, { gap: "3", children: [
                    /* @__PURE__ */ a(
                      xt,
                      {
                        type: "time",
                        value: yt,
                        onChange: (o) => Z(o.currentTarget.value),
                        h: "40px",
                        w: "140px",
                        bg: "bg",
                        color: "fg",
                        borderColor: "border",
                        borderRadius: "md"
                      }
                    ),
                    /* @__PURE__ */ a(z, { color: "fg.subtle", children: "→" }),
                    /* @__PURE__ */ a(
                      xt,
                      {
                        type: "time",
                        value: Mt,
                        onChange: (o) => X(o.currentTarget.value),
                        h: "40px",
                        w: "140px",
                        bg: "bg",
                        color: "fg",
                        borderColor: "border",
                        borderRadius: "md",
                        disabled: t === "single"
                      }
                    )
                  ] })
                ] }) : null
              ] }),
              /* @__PURE__ */ a(
                F.Footer,
                {
                  bg: "bg",
                  borderTop: "1px solid",
                  borderColor: "border.muted",
                  px: "4",
                  py: "3",
                  position: "sticky",
                  bottom: "0",
                  zIndex: "1",
                  children: /* @__PURE__ */ h(ge, { justifyContent: "flex-end", w: "full", children: [
                    /* @__PURE__ */ a(bt, { variant: "ghost", onClick: () => R(!1), children: "Cancel" }),
                    /* @__PURE__ */ a(bt, { variant: "solid", onClick: te, children: "Apply" })
                  ] })
                }
              )
            ]
          }
        ) }) })
      ]
    }
  );
}, Pe = O.memo(Fe);
Pe.displayName = "DateTimeRangePicker";
const gr = ({
  open: t,
  onOpenChange: e,
  title: r,
  icon: n,
  header: s,
  children: u,
  footer: p,
  positionerProps: L,
  contentProps: x,
  headerProps: Q,
  bodyProps: J,
  footerProps: K,
  closeButtonProps: I,
  showCloseButton: lt = !0,
  ...T
}) => /* @__PURE__ */ a(M.Root, { lazyMount: !0, open: t, onOpenChange: e, ...T, children: /* @__PURE__ */ h(Ht, { children: [
  /* @__PURE__ */ a(M.Backdrop, {}),
  /* @__PURE__ */ a(M.Positioner, { px: { base: "4", md: "6" }, py: { base: "4", md: "8" }, ...L, children: /* @__PURE__ */ h(M.Content, { w: "full", maxW: "container.md", mx: "4", borderRadius: "l3", overflow: "hidden", ...x, children: [
    s ?? (r ? /* @__PURE__ */ a(M.Header, { px: "6", pt: "6", pb: "4", ...Q, children: n ? /* @__PURE__ */ h(V, { gap: "3", children: [
      /* @__PURE__ */ a(U, { as: n, boxSize: "6", color: "fg.muted" }),
      /* @__PURE__ */ a(M.Title, { children: r })
    ] }) : /* @__PURE__ */ a(M.Title, { children: r }) }) : null),
    /* @__PURE__ */ a(M.Body, { px: "6", pb: "6", ...J, children: u }),
    p ? /* @__PURE__ */ a(M.Footer, { px: "6", pb: "6", ...K, children: p }) : null,
    lt ? /* @__PURE__ */ a(M.CloseTrigger, { asChild: !0, children: /* @__PURE__ */ a(fe, { size: "sm", ...I }) }) : null
  ] }) })
] }) });
export {
  gr as A,
  Pe as D,
  ve as L,
  ye as a,
  $e as b,
  He as c,
  ar as d,
  hr as e,
  cr as f,
  Ke as g,
  Je as h,
  dr as i,
  tr as j,
  ur as k,
  ir as l,
  Ge as m,
  Ue as n,
  Xe as o,
  nr as p,
  rr as q,
  qe as r,
  _e as s,
  Qe as t,
  sr as u,
  lr as v,
  er as w,
  Ze as x,
  Ve as y,
  or as z
};
